import dayjs from 'dayjs';

export const defaultSinistreFormValue = {
  numeroContrat: '',
  nomDeclarant: '',
  nomContractant: '',
  telephone: '',
  dateSinistre: dayjs().startOf('day').toDate(),
  lieuSinistre: '',
  agence: '',
  circonstanceAccident: '',
  photo: '',
  pieceJointeAgence: '',
  estimationPrejudice: '',
};
